$(document).ready(function(){

  // Element is in viewport or not
  function isInViewport(element) {
    var rect = element[0].getBoundingClientRect();
    var html = document.documentElement;
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || html.clientHeight) &&
      rect.right <= (window.innerWidth || html.clientWidth)
    );
  }
  // Element is in viewport or not

  // _________________ Announcementbar
  if($('#announcement-bar-close').length > 0){
    $('#announcement-bar-close').click(function() {
      $(this).parents('.announcement-bar-section').fadeOut();
      $('html').css('--header-bottom-position','0px');
    });
  }
  // _________________ Announcementbar

  // _________________ Header Drawer
  $('#menu-drawer__close').click(function(e) {
    e.preventDefault();
    $('#Details-menu-drawer-container .header__icon--menu').click();
    $('.menu-drawer .menu-drawer__submenu').slideUp();
    $('.menu-drawer .menu-drawer__menu-item.sub-menu_link').removeClass('active');
  });

  $('.menu-drawer__menu-item.sub-menu_link .icon__arrow').click(function(e) {
    e.preventDefault();
    $(this).parent('.menu-drawer__menu-item.sub-menu_link').toggleClass('active');
    $(this).parent('.menu-drawer__menu-item.sub-menu_link').siblings('.menu-drawer__submenu').slideToggle();
  });
  // _________________ Header Drawer


  // _________________ Scroll Top Button
  if($('#scroll-to-top').length > 0){
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        $('#scroll-to-top').addClass('show');
      } else {
        $('#scroll-to-top').removeClass('show');
      }
    });
    
    $('#scroll-to-top').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });
  }
  // _________________ Scroll Top Button


  // _________________ Title animation
  if($('.fade-animated-title').length > 0){
    $('.fade-animated-title').each(function(){
      var a = $(this).text().split('');
      var text = $(this);
      text.empty();
      $(a).each(function(i, a){
        text.append('<span style="transition-delay: '+ (i*0.1) +'s;">'+a+'</span>');
      });
    });
    $(window).on('scroll',function () {
      $('.fade-animated-title').each(function(){
        var a = $(this)
        if(isInViewport($(this))){
          $(this).addClass('faded');
        }else{
          $(this).removeClass('faded');
        }
      });
    })
  }
  // _________________ Title animation


  // _________________ Contact Form Text area max char  
  $('#text-area-max-char textarea').on('input',function () {
    var max = $(this).attr('maxlength');
    var len = $(this).val().length;
    $('#max-char-text span').text(max - len);
    text_area_max_char_resize($(this));
  });
  function text_area_max_char_resize ($text) {
      $text.css('height', 'auto');
      $text.css('height', $text[0].scrollHeight + 4 +'px');
  }
  
  // _________________ Contact Form Text area max char


  // _________________ Sort Popup
  if($('.sort_by-popup').length > 0){
    $(document).on('click','.sort_by-popup #sort_by-popup-btn',function (e) {
      e.preventDefault();
      $(this).parent('.sort_by-popup').toggleClass('open_popup');
    });
    $('body').on('click',function(event){
       if(!$(event.target).is('.sort_by-popup') && !$(event.target).is('#sort_by-popup-btn')){
         $(".sort_by-popup").removeClass("open_popup");
       }
    });
  }
  // _________________ Sort Popup



  // _________________ Facet
  $(document).on('click','.mobile-facets__close',function(e){
    e.preventDefault();
    $('.mobile-facets__open-wrapper').click(); 
  });
  
  
  if($('.facet_block---wrap').length > 0){
    $(document).on('click','.facet_block---wrap .facet_block---toggle',function(){
      $(this).parents('.facet_block---wrap').toggleClass('active');
      $(this).next('.facet_block---content').slideToggle();
    });
  }

  // _________________ Collection bottom section one
  if($('.collection-section-one').length > 0){
  $('.collection-section-one .accordian-bar-block .accordian-bar-block-title').click(function () {
    $(this).next('.accordian-bar-block-desc').slideToggle().parents('.accordian-bar-block').toggleClass('active');
  });
  }
  // _________________ Collection bottom section one

  // _________________ Collection section as accordion
  if($('[data-section-as-accoridan-in-mobile]').length > 0){
    $('[data-section-as-accoridan-in-mobile] [data-section-as-accoridan-title]').click(function () {
      if($(window).width() < 750){
        $(this).next('[data-section-as-accoridan-content]').slideToggle().parents('[data-section-as-accoridan-in-mobile]').toggleClass('active');
      }
    });
  }
  // _________________ Collection section as accordion

   // _________________ FAQ
  if($('[data-faq-block]').length > 0){
    $('[data-faq-block] [data-faq-toggle]').click(function (e) {
      e.preventDefault();
      $(this).next('[data-faq-content]').slideToggle().parents('[data-faq-block]').toggleClass('active');
    });
  }
  // _________________ FAQ


  // _________________ Map and Slider
  if($('.map-and-slider .map-content-block-slider').length > 0){
    var map_and_slider = new Swiper(".map-and-slider .map-content-block-slider", {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      navigation: {
        nextEl: '.map-and-slider .map-content-block-slider .swiper-button-next',
        prevEl: '.map-and-slider .map-content-block-slider .swiper-button-prev',
      },
      pagination: {
        el: '.map-and-slider .map-content-block-slider .swiper-pagination',
        clickable: true,
      },
      mousewheel:{
        forceToAxis: true
      },
      on: {
        slideChange: function () {
          var currentSlide = this.slides[this.activeIndex],
            country = currentSlide.dataset.country;
          $('.map-and-slider .map-svg .map-path').removeClass('active');
          $('.map-and-slider .map-svg .map-path[data-country="'+ country +'"]').addClass('active');
        }
      }
    });
    
    $('.map-and-slider .map-svg .map-path').eq(0).addClass('active');
    $('.map-and-slider .map-svg .map-path').click(function () {
      var country = $(this).data('country');
      console.log(country)
      $(this).addClass('active').siblings().removeClass('active');
      var index = $('.map-and-slider .map-content-block-slider .map-content-block[data-country="'+ country +'"]').data('index');
      map_and_slider.slideTo(index - 1, 0);
    });
    
  }
  // _________________ Map and Slider

  var screenLoading = false;
  var screenDelay = 100;

  function pInfScrExecute() {
    var loadingImage,loadingmore;
    pInfScrNode = $('.load-more-block').last();
    pInfScrmore = $('.load-more-block [data-load]').last();
    pInfScrURL = $('.load-more-block [data-load]').last().attr("data-href");
    if(!screenLoading && pInfScrNode.length > 0  && pInfScrNode.css('display') != 'none') {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          screenLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('<img src="https://cdn.shopify.com/s/files/1/0613/6699/3117/files/loading.gif?v=1645597902" />');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
          pInfScrmore.hide();
        },
        success: function(data) {
          pInfScrNode.next().remove();
          pInfScrmore.next().remove();
          var filteredData = $(data).find("[data-load-content]").html();
          $('[data-load-content]').append(filteredData);
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          loadingImage.remove();
          screenLoading = false;
        },
        dataType: "html"
      });

    }
  }

  $('body').on('click', '[data-load]', function(e){
    e.preventDefault();
    if (document.querySelector("[data-load-content]")) {
      setTimeout(function(){
        pInfScrExecute();
      }, screenDelay);
      if( $(document).height() - 1500 > $(document).scrollTop() + $(window).height() ) {
        screenDelay = 100;
      }
    }
  });


  // _________________Butchers Guide
  if($('.butchers-guide .butchers-guide-slider').length > 0){
    var butchers_guide = new Swiper(".butchers-guide .butchers-guide-slider", {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      navigation: {
        nextEl: '.butchers-guide .butchers-guide-slider .swiper-button-next',
        prevEl: '.butchers-guide .butchers-guide-slider .swiper-button-prev',
      },
      mousewheel:{
        forceToAxis: true
      },
      on: {
        slideChange: function () {
          var slide_index = this.activeIndex + 1;
          $('.butchers-guide #butchers-cow-svg .cow-path').removeClass('active');
          $('.butchers-guide #butchers-cow-svg .cow-path#cow-path-' + slide_index).addClass('active');
        }
      }
    });
    $('.butchers-guide .butchers-guide-faq .butchers-guide-faq-toggle').click(function (e) {
      e.preventDefault();
      $(this).next('.butchers-guide-faq-content').slideToggle().parents('.butchers-guide-faq').toggleClass('active');
      $(this).parents('.butchers-guide-faq').siblings().removeClass('active').find('.butchers-guide-faq-content').slideUp();
    });

    $('.butchers-guide #butchers-cow-svg .cow-path#cow-path-1').addClass('active');
    $('.butchers-guide #butchers-cow-svg .cow-path').click(function () {
      var id = $(this).attr('id');
      $(this).addClass('active').siblings().removeClass('active');
      id = id.replace('cow-path-','');
      butchers_guide.slideTo(id-1, 0);
    });
  }
  // _________________Butchers Guide

  // _________________subscription step popup
  if($('.subscription-step-popup').length > 0){
    $('.subscription-step-popup .subscription-step-toggle,.subscription-step-popup .subscription-step-popup-close').click(function (e) {
      e.preventDefault();
      $('body').toggleClass('oveflow-hidden');
      $(this).parents('.subscription-step-popup').toggleClass('active');
      $(this).parents('.subscription-step-popup').find('.subscription-step-popup-block').fadeToggle();
      var top_pos = $('.section-header').height() + $('.section-header').offset().top + 8;
      $(this).parents('.subscription-step-popup').css('--mobile-top-position',top_pos+'px')
    });
  }
  // _________________subscription step popup

  // _________________subscription box size
  if($('.main-box-size input[data-title-change]').length > 0){
    $('.main-box-size input[data-title-change]').change(function() {
      var title = $(this).data('title');
      $(this).parents('.main-box-size-block').find('.box-title').text(title);
    });
  }
  // _________________subscription box size

  // _________________ Subscription Cart drawer
  if($('#subscription-cart').length > 0){
    // $('body').on('click', '#view-selected-subscription-product', function(e) {
    //   e.preventDefault();
    //   $('.subscription-cart').addClass('open-subscription-cart');
    //   $('body').addClass('overflow-hidden');
    // });
    $('body').on('click', '#cart-icon-bubble-sub', function(e) {
      e.preventDefault();
      $('.subscription-cart').addClass('open-subscription-cart');
      $('body').addClass('overflow-hidden');
    });
  }
  $('body').on('click', '#subscription-cart-close, #subscription-cart .subscription-cart-overlay', function(e) {
    e.preventDefault();
    $('.subscription-cart').removeClass('open-subscription-cart');
    $('body').removeClass('overflow-hidden');
  })

  // _________________ Subscription Cart drawer

  // _________________ Product media
  if($('.product_main_media_wrap').length > 0){
    var product_main_thumb_list = new Swiper ('.main-product-wrap #product_main_thumbnail', {
      slidesPerView: 4,
      watchSlidesProgress: true,
      spaceBetween: 12,
      breakpoints: {
        750: {
          spaceBetween: 16,
        }
      }
    });
    // DW CRO v1: loop + thumbs + mobile viewport resizes left the main slide offset (black area seen in Hotjar on mobile PDPs).
    // rewind keeps prev/next circular without cloned slides; observers + roundLengths recompute on resize.
    var product_main_media_list = new Swiper(".main-product-wrap #product_main_media_list", {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      rewind: true,
      roundLengths: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation: {
        nextEl: '.main-product-wrap #product_main_media_list .swiper-button-next',
        prevEl: '.main-product-wrap #product_main_media_list .swiper-button-prev',
      },
      pagination: {
        el: '.main-product-wrap #product_main_media_list .swiper-pagination',
        clickable: true,
      },
      mousewheel:{
        forceToAxis: true
      },
      thumbs: {
        swiper: product_main_thumb_list,
      }
    });
  }
  // _________________ Product media


  // _________________ Product sticky cart
  if ($("#product-sticky-cart").length > 0) {
    $(window).scroll(function () {
      var btn_pos = $(".main-product-wrap .product__info-wrapper product-form").offset().top;
      var footer_pos_top = $("footer.footer").offset().top;
      var viewporttop = $(this).scrollTop();
      var viewportbottom = $(window).height() + $(this).scrollTop();
      if (viewporttop > btn_pos && viewportbottom < footer_pos_top) {
        $("#product-sticky-cart").fadeIn(500);
      } else {
        $("#product-sticky-cart").fadeOut(500);
      }
    });
    $('body').on('click', '[data-sticky-button]', function(e) {
      e.preventDefault();
      $('[data-main-add]').trigger('click');
    });
  }
  // _________________ Product sticky cart

  
  // _________________ thankyou page video
  if($('[data-thank-you-video]').length > 0){
    $('[data-thank-you-video]').click(function () {
      if($(this).hasClass('play-video')){
        $(this).removeClass('play-video');
        $(this).find('video')[0].pause();
      }else{
        $(this).addClass('play-video');
        $(this).find('video')[0].currentTime = 0;
        $(this).find('video')[0].play();
      }
    });
  }
  // _________________ thankyou page video


  // _________________ Lifesaver discount popup
  if($('#lifesaver-discount-popup').length > 0){
    $('a[href="#lifesaver-discount-popup-toggle"]').click(function (e) {
      e.preventDefault();
      $('#lifesaver-discount-popup').addClass('popup-open');
      $('body').addClass('overflow-hidden');
    });
    $('#lifesaver-discount-popup .popup-overlay,#lifesaver-discount-popup-close').click(function (e) {
      e.preventDefault();
      $('#lifesaver-discount-popup').removeClass('popup-open');
      $('body').removeClass('overflow-hidden');
    });
  }
  // _________________ Lifesaver discount popup


  // _________________ Account Password field
  $('.password-field .password-icon').click(function () {
    $(this).parents('.password-field').toggleClass('show-password');
    var input = $(this).parents('.password-field').find('input');
    if (input.attr("type") === "password") {
      input.attr("type", "text");
    } else {
      input.attr("type", "password");
    }
  });
  // _________________ Account Password field


  // _________________ Account Page Order and info Toggle
  if($('[data-account-tab]').length > 0){
    $('[data-account-tab-toggle]').click(function (e) {
      e.preventDefault();
      var target = $(this).attr('href');
      if(!$(this).hasClass('current')){
        $(this).addClass('current').siblings().removeClass('current');
        window.history.pushState('', '', target.replace('#','?'));
        target = target.split('#');
        $('[data-account-tab]#' + target[1]).fadeIn().siblings('[data-account-tab]').hide();
      }
    });
  }

  if($('.account-orders-wrap').length > 0){
    $('.view-order-details').click(function (e) {
      e.preventDefault();
      $(this).parents('.account-orders-row-wrap').toggleClass('open-product-details');
      $(this).parents('.account-orders-row-wrap').find('.order-products-wrap').slideToggle();
    });
  }
  
  // _________________ Account Page Order and info Toggle

  if($('[data-mobile-code]').length > 0){
    $("[data-mobile-code]").intlTelInput({
    	initialCountry: "in",
    	separateDialCode: true,
    });
  }

  $('body').on('change', '#remember-login', function() {
    if ($(this).is(':checked')) {
      $('#register_btn').removeAttr('disabled');
      $('#register_btn').removeClass('button--secondary');
    } else {
      $('#register_btn').attr('disabled', 'disabled');
      $('#register_btn').addClass('button--secondary');
    }
  });


  // _________________ Account Page Order and info Toggle
  if($('.banner-info-popup').length > 0){
    $('.banner-info-popup .banner-info-popup-icon').click(function (e) {
      e.preventDefault();
      $(this).parents('.banner-info-popup').toggleClass('active');
      $(this).parents('.banner-info-popup').find('.banner-info-popup-content').fadeToggle();
      // var top_pos = + $(this).offset().top + 8;
      // $(this).parents('.banner-info-popup').css('--mobile-top-position',top_pos+'px')
    });
  }
  // _________________ Account Page Order and info Toggle


  // _________________ Subscription Box
  if($('.subscription-box .box-include-info').length > 0 && $(window).width() < 750){
    $('.subscription-box .box-include-info.active .box-include-info-toggle').click();
  }
  // _________________ Subscription Box


  // _________________ Product How To Cook Instructions
  if($('.product-how-to-cook').length > 0){
    if($('.instruction-info-slider').length > 0){
      var subscription_packages_slider = new Swiper ('.product-how-to-cook .instruction-info-slider', {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: '.product-how-to-cook .instruction-info-blocks .swiper-button-next',
          prevEl: '.product-how-to-cook .instruction-info-blocks .swiper-button-prev',
        },
        pagination: {
          el: '.product-how-to-cook .instruction-info-blocks .swiper-pagination',
          clickable: true,
        },
        mousewheel:{
          forceToAxis: true
        },
      });
    }

    $('.product-how-to-cook .product-how-to-cook-toggle').click(function (e) {
      e.preventDefault();
      if(!$(this).hasClass('active')){
        $(this).addClass('active');
        $(this).siblings('.product-how-to-cook-toggle').removeClass('active');
        let tab = $(this).data('tab-target');
        $('.product-how-to-cook .product-how-to-cook-tab[data-tab="'+ tab +'"]').removeClass('hidden');
        $('.product-how-to-cook .product-how-to-cook-tab:not([data-tab="'+ tab +'"])').addClass('hidden');
      }
    }) 
  }
  // _________________ Product How To Cook Instructions
  
  // Subscription Box Frequency selection 
  $('body').on('change', '.product-subscription-block input[name="purchase-type"]', function(e) {
    var parent_class = $(this).closest('.product-subscription-block');
    if (parent_class.find('input[name="purchase-type"]:checked').val() == 'subscribe') {
      parent_class.find('.selling_plan').removeAttr('disabled');
      parent_class.find('.onetime_col').removeClass('active');
      parent_class.find('.subscription_col').addClass('active');
    } else {
      parent_class.find('.selling_plan').attr('disabled', 'disabled');
      parent_class.find('.subscription_col').removeClass('active');
      parent_class.find('.onetime_col').addClass('active');
    }
  });

  
});